import React from 'react';
import { Link } from 'react-router-dom';
import { BlobBackground } from '../obros/BlobBackground';
import { Logo } from '../obros/Logo';

export const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    // h-screen + overflow-hidden en el shell, con <main> como única región que scrollea:
    // en pantallas donde el contenido entra (login) no aparece scroll de más.
    <div className="relative h-screen bg-cream2 flex flex-col overflow-hidden">
      <BlobBackground variant="hero" />
      <header className="relative z-10 w-full px-6 py-4 shrink-0">
        <Link to="/" className="w-fit block">
          <Logo className="h-7" />
        </Link>
      </header>
      <main className="relative z-10 flex-1 overflow-y-auto flex items-center justify-center px-4 pb-8">
        {children}
      </main>
    </div>
  );
};
